export default function HeroSection() {
  return (
    <section className="relative w-full bg-background-50 pt-20 pb-16 md:pt-28 md:pb-24 px-4 md:px-6">
      <div className="w-full max-w-[1200px] mx-auto">
        <h1 className="text-center text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-900 mb-16 md:mb-20 animate-fade-up">
          <span className="text-foreground-900">(Vorteksi</span>{' '}
          <span className="text-primary-500">OU)</span>
        </h1>

        <div className="flex flex-col lg:flex-row gap-5">
          <div className="w-full lg:w-[55%]">
            <div className="relative w-full overflow-hidden rounded-2xl bg-background-200" style={{ aspectRatio: '4/5' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20layers%20representing%20system%20architecture%20with%20overlapping%20translucent%20planes%20in%20soft%20warm%20gray%20and%20teal%20tones%20clean%20minimal%20composition%20soft%20ambient%20lighting%20editorial%20quality%20high%20detail%20harmonious%20composition%20no%20text%20no%20people%20pure%20abstract%20technical%20visualization&width=800&height=1000&seq=hero-left-01&orientation=portrait"
                alt="Abstract system architecture visualization"
                title="System architecture visualization"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 p-6 md:p-8 bg-gradient-to-t from-foreground-900/70 to-transparent w-full">
                <p className="text-background-50 text-lg md:text-xl font-body font-medium leading-snug">
                  Scalable architecture.<br />Lasting foundations.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[45%] flex flex-col gap-5">
            <div className="w-full flex-1">
              <div className="relative w-full h-full overflow-hidden rounded-2xl bg-secondary-100" style={{ minHeight: '200px' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20modular%20component%20diagram%20with%20rounded%20interface%20elements%20in%20soft%20sage%20green%20and%20warm%20gray%20palette%20clean%20geometric%20shapes%20minimal%20abstract%20tech%20visualization%20soft%20diffused%20lighting%20editorial%20photography%20style%20no%20text%20no%20people&width=800&height=500&seq=hero-right-top-02&orientation=landscape"
                  alt="Modular component architecture visualization"
                  title="Modular component architecture visualization"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="w-full flex-1">
              <div className="relative w-full h-full overflow-hidden rounded-2xl bg-accent-100" style={{ minHeight: '200px' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20data%20flow%20pattern%20with%20warm%20coral%20and%20cream%20tones%20interconnected%20geometric%20nodes%20soft%20minimal%20composition%20abstract%20technical%20systems%20visualization%20clean%20aesthetic%20high%20detail%20no%20text%20no%20people&width=800&height=500&seq=hero-right-bottom-03&orientation=landscape"
                  alt="Technical systems flow visualization"
                  title="Technical systems flow visualization"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}